import React from 'react';
import { CreatePost, Feed, Navbar } from '../../containers';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import './style.css';


const Home = () => {

    return (
    <div className="home">
      <Navbar />
      <ToastContainer
          position="top-center"
          autoClose={1500}
          newestOnTop
        ></ToastContainer>
      <CreatePost />
      <Feed />        
    </div>  );
}
 
export default Home;